import * as types from './actionTypes';

export function changeResponsiveMode(responsiveMode) {
    return { type: types.RESPONSIVE_MODE_CHANGE, responsiveMode };
}
